export const FETCH_MESSAGE = 'FETCH_MESSAGES'
export const FETCH_MESSAGE_SUCCESS = 'FETCH_MESSAGES_SUCCESS'
export const FETCH_MESSAGE_FAILURE = 'FETCH_MESSAGE_FAILURE'